import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/uploadImage.scss";
import ImageDimensions from "../Cards/imageDimension";
import ImageQuality from "../Cards/imageQuality";
import ImageType from "../Cards/imageType";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SaveSettings } from "../../actions/Settings/Setting";
import ButtonRounded from "../Signature/button";
import CancelButton from "../Cancel_button/Cancel_button";
const SettingsModal = ({ open, setOpen, handleDone, parent = true }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const downloadState = useSelector((state) => state["downloadSlice"]);

  const uploaded = () => {
    if (parent) handleDone();
    setOpen(false);
  };
  const handleSaveSettings = () => {
    dispatch(SaveSettings(downloadState, uploaded));
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model p-0 m-0">
          <CancelButton close={() => setOpen(false)} />
          <Col className="mt-4 pt-1">
            <Row>
              <Row className="d-flex justify-content-center productSansBold text_18 line_height_100pc black_0C0C0C">
                {t("DownloadImage.Title")}
              </Row>
              <Row className="productSansLight text_15 mt-2 d-flex justify-content-center">
                {t("DownloadImage.Discription")}
              </Row>
            </Row>
            <Col className="border-top my-4 pb-1 mx-4">
              <Col className="px-5 pb-1">
                <Col className="mt-4 pt-1">
                  <ImageType downloadState={downloadState} />
                </Col>
                <Col className="mt-3">
                  <ImageDimensions downloadState={downloadState} />
                </Col>
                <Col className="mt-3">
                  <ImageQuality downloadState={downloadState} />
                </Col>
              </Col>

              <ButtonRounded
                onclick={handleSaveSettings}
                text={"Save"}
                style={"w_edit_button continue_button  mt-4"}
              />
            </Col>
          </Col>
        </Row>
      </Fade>
    </Modal>
  );
};

export default SettingsModal;
